export const MEN_REQUEST_PENDING = "MEN_REQUEST_PENDING";
export const MEN_REQUEST_FAILURE = "MEN_REQUEST_FAILURE";
export const MEN_REQUEST_SUCCESS = "MEN_REQUEST_SUCCESS";
export const WOMEN_REQUEST_SUCCESS = "WOMEN_REQUEST_SUCCESS";